import { useEffect, useState, type JSX } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useExchangeCodeMutation } from '../api';

export function OAuthCallbackPage(): JSX.Element {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [exchange] = useExchangeCodeMutation();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = params.get('code');
    if (!code) {
      setError(t('oauth.failed'));
      return;
    }
    exchange({ code })
      .unwrap()
      .then(() => navigate('/', { replace: true }))
      .catch(() => setError(t('oauth.failed')));
  }, [params, exchange, navigate, t]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4 py-12">
      <div className="w-full max-w-md">
        <Card data-testid="oauth-callback-page">
          <CardHeader>
            <CardTitle>{error ?? t('oauth.exchanging')}</CardTitle>
            {!error && (
              <CardDescription className="flex items-center gap-2">
                <Loader2 className="h-4 w-4 animate-spin" />
                <span>OrderMesh</span>
              </CardDescription>
            )}
          </CardHeader>
          {error && (
            <CardContent>
              <Button onClick={() => navigate('/signin', { replace: true })}>
                {t('forgotPassword.backToSignIn')}
              </Button>
            </CardContent>
          )}
        </Card>
      </div>
    </main>
  );
}
